/** The nationality a new student record starts with when none is given
 * (Sri Lanka, by ISO code in the Country master data). Mirrors the
 * backend's own default for new records. */
export const DEFAULT_NATIONALITY_ISO2 = 'LK';

/** The Sri Lanka country id to start a new record with, or null when the
 * nationality is already set (a saved value is never replaced) or Sri
 * Lanka isn't in the master data. */
export const defaultNationalityId = (
  currentNationalityId: number | '',
  countries: Array<{ id: unknown; iso2?: unknown }> | undefined,
): number | null => {
  if (currentNationalityId !== '' || !countries) return null;
  const sriLanka = countries.find((c) => c.iso2 === DEFAULT_NATIONALITY_ISO2);
  return sriLanka ? (sriLanka.id as number) : null;
};
